// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const kyurem_white: PokeData = {
  "id": 10023,
  "name": "kyurem-white",
  "height": 36,
  "weight": 3250,
  "base_experience": 350,
  "types": [
    PokeType.DRAGON,
    PokeType.ICE
  ],
  "api_moves": [
    "ice-beam",
    "blizzard",
    "dragon-rage",
    "slash",
    "icy-wind",
    "outrage",
    "dragon-breath",
    "ancient-power",
    "endeavor",
    "imprison",
    "hyper-voice",
    "sheer-cold",
    "dragon-pulse",
    "ice-burn",
    "fusion-flare",
    "noble-roar",
    "freeze-dry"
  ],
  "moves": [
    "blizzard",
    "outrage",
    "dragon-breath",
    "ancient-power",
    "hyper-voice",
    "sheer-cold",
    "dragon-pulse",
    "ice-fang",
    "ice-shard",
    "avalanche",
    "dragon-fang",
    "ice-punch",
    "dragon-vortex"
  ],
  "evolution_chain": {
    "id": 333,
    "item": null,
    "species": [
      {
        "name": "kyurem",
        "order": 647,
        "types": [
          PokeType.DRAGON,
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 117,
    "speed": 101,
    "ability_power": 181
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
